import React 		from 'react'
import classnames 	from 'classnames'
import Helmet 		from 'react-helmet'
import { connect } 	from 'react-redux'

import '../lib/styles/index.styl'

import Header 			from '../components/header'
import HeaderMenus 		from '../components/header-menus'
import PageTransition 	from '../components/page-transition'
import { 
	ResizeMonitor,
	ScrollMonitor
} from '../components/ui-monitors'

import {
	toggleMenu,
	typeLoad
} from '../redux/actions'

import {
	locationHasChanged
} from '../lib/_helpers'

let WebFont = null
if(typeof window !== 'undefined'){
	WebFont = require('webfontloader')
}

class Layout extends React.Component {
	constructor(props) {
		super(props)
	}

	componentDidMount(){
		if(WebFont){
			WebFont.load({
				custom: ['ModernEra-Regular', 'ModernEra-Medium', 'Calibre-Regular', 'Calibre-Medium'],
				active: () => {
					this.triggerTypeLoaded()
				},
				inactive: () => {
					this.triggerTypeLoaded()
				}
			})
		}
	}

	componentDidUpdate(prevProps){
		const {
			dispatch
		} = this.props

		if(locationHasChanged(prevProps.location, this.props.location)){
			if(this.props.menuOpen){
				dispatch(toggleMenu(null))
			}
		}
	}

	componentWillUnmount(){
		this.clearTypeLoadTO()
	}

	triggerTypeLoaded(){
		const {
			dispatch
		} = this.props
		
		this.clearTypeLoadTO()
		this.typeLoadTO = setTimeout(() => {
			dispatch(typeLoad(true))
		}, 100)
	}

	clearTypeLoadTO(){
		if(this.typeLoadTO){ clearTimeout(this.typeLoadTO) }
	}

	render() {
		const {
			children,
			menuOpen,
			hasTouch,
			location,
			typeLoaded,
			dispatch
		} = this.props

		const title = 'Endomag'

		return <React.Fragment>
			<Helmet>
				<meta charSet="utf-8" />

				<meta name="viewport" content="initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scaleable=no" />
				<meta name="msapplication-tap-highlight" content="no" />
				<meta name="apple-mobile-web-app-capable" content="yes"/>
				<meta name="apple-mobile-web-app-status-bar-style" content="black" />
				<meta name="apple-mobile-web-app-title" content={ title } />
				
				<title>{ title }</title>

				<body className={ classnames({
					'site--hasTouch': !!hasTouch,
					'site--hasOverlay': !!menuOpen,
					'site--loaded': typeLoaded
				}) } />
			</Helmet>

			<Header
				location={ location } />

			<PageTransition
				location={ location }>
				{ children }
			</PageTransition>

			<ResizeMonitor />
			<ScrollMonitor />
		</React.Fragment>
	}
}

const mapStateToProps = (state) => {
	const {
		ui
	} = state

	return {
		hasTouch: ui.hasTouch,
		menuOpen: ui.menuOpen,
		typeLoaded: ui.typeLoaded
	}
}

export default connect(mapStateToProps)(Layout)